<template>
  <div class="login-page">
    <v-container fluid class="fill-height pa-0">
      <v-row no-gutters align="center" justify="center" class="fill-height">
        <v-col cols="12" sm="10" md="6" lg="4">
          <v-card class="login-card pa-8" elevation="12">
            <div class="text-center mb-6">
              <h1 class="login-title">Urgencias | MediCover</h1>
              <v-divider class="my-4"></v-divider>
              <h3 class="login-subtitle">Bienvenido. Ingresa tus credenciales para continuar.</h3>
            </div>

            <v-form @submit.prevent="login" ref="loginForm">
              <v-text-field
                v-model="email"
                label="Usuario"
                outlined
                dense
                clearable
                required
                prepend-inner-icon="mdi-email"
                class="mb-4 login-input"
                background-color="white"
              />

              <v-text-field
                v-model="password"
                :type="showPassword ? 'text' : 'password'"
                label="Contraseña"
                outlined
                dense
                clearable
                required
                prepend-inner-icon="mdi-lock"
                :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                @click:append="togglePasswordVisibility"
                :rules="contrarquerido"
                class="mb-4 login-input"
                background-color="white"
              />

              <v-alert v-if="mostrarerror" type="error" dense text class="mb-4">
                {{ errormensaje }}
              </v-alert>

              <v-btn
                color="azul_med"
                block
                large
                rounded
                dark
                type="submit"
                class="mb-4 login-btn"
              >
                Iniciar sesión
              </v-btn>

              <div class="text-center">
                <v-btn
                  :href="WhatsApp"
                  target="_blank"
                  text
                  small
                  color="primary"
                  style="text-transform: none;"
                >
                  ¿Necesitas ayuda?
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import { encryptPassword } from "@/utils/cryptoService";
export default {
  name: 'LoginView',
  validations: {
  },
  data: () => ({
    WhatsApp: `https://wa.me/send?phone=${process.env.VUE_APP_BASE_PHONEWHATSWEB}&text=${encodeURIComponent('Hola, necesito ayuda al iniciar sesión como hospital')}`,
    email: '',
    mostrarerror: false,
    errormensaje: null,
    password: '',
    showPassword: false,
    contrarquerido: [
      (v) => !!v || 'Contraseña requerida'
    ]
  }),
  computed: {
    checkboxErrors() {
      const errors = []
      if (!this.$v.checkbox.$dirty) return errors
      // !this.$v.checkbox.checked && errors.push('You must agree to continue!');
      return errors
    },
    selectErrors() {
      const errors = []
      if (!this.$v.select.$dirty) return errors
      // !this.$v.select.required && errors.push('Item is required');
      return errors
    },
    nameErrors() {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long');
      // !this.$v.name.required && errors.push('Name is required.');
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      // !this.$v.email.email && errors.push('Must be valid e-mail');
      // !this.$v.email.required && errors.push('E-mail is required');
      return errors
    }
  },
  created() {
    this.$store
      .dispatch('logout', {})
  },
  beforeMount() {
  },
  mounted() {
  },

  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    validate() {
      // this.$refs.form.validate();
    },
    async login() {
      try {
        //Se pudiera esperar url del backend
        await this.$store.dispatch('login', {
          email: this.email,
          password: encryptPassword(this.password),
          tipo: 'hospital'
        });
        //const redirect = this.$route.query.redirect;
        //this.$router.replace(redirect);
        this.$router.replace('/hospital/urgencias-medicas');
      } catch (error) {
        this.mostrarerror = true;
        this.errormensaje = "No se pudo iniciar sesión. Verifica tu usuario y contraseña e inténtalo nuevamente.";
      }
    },
    submit() {
      this.$v.$touch()
    },
    clear() {
      this.$v.$reset()
      this.name = ''
      this.email = ''
    }
  }
}
</script>
<style scoped>
.login-page {
  min-height: 100vh;
  width: 100%;
  background-image:
    linear-gradient(rgba(8, 24, 43, 0.45), rgba(8, 24, 43, 0.45)),
    url('https://medicover.mx/img/login-agente.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.fill-height {
  min-height: 100vh;
}

.login-card {
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.88);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  box-shadow: 0 20px 45px rgba(0, 0, 0, 0.25) !important;
}

.login-title {
  font-size: 2.2rem;
  font-weight: 300;
  color: #1f2937;
  margin: 0;
}

.login-subtitle {
  font-size: 1.1rem;
  font-weight: 500;
  color: #374151;
  margin: 0;
}

.login-input ::v-deep .v-input__slot {
  background: #ffffff !important;
  border-radius: 12px !important;
}

.login-btn {
  height: 52px !important;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.5px;
}

@media (max-width: 600px) {
  .login-card {
    margin: 16px;
    padding: 24px !important;
  }

  .login-title {
    font-size: 1.8rem;
  }
}
</style>